import { render, staticRenderFns } from "./StaffNavigationMobile.vue?vue&type=template&id=16344c72"
import script from "./StaffNavigationMobile.vue?vue&type=script&lang=js"
export * from "./StaffNavigationMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports